/* Ember theme JS: drawers, AJAX cart, variant picker, gallery, sticky add-to-cart. No dependencies. */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const routes = window.EmberRoutes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', root: '/' };
  const cartType = document.body.dataset.cartType || 'drawer';

  /* ---------- Drawers ---------- */
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    const focusable = d.querySelector('button, a, input');
    focusable && focusable.focus({ preventScroll: true });
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      if (opener.dataset.openDrawer === 'CartDrawer' && cartType !== 'drawer') return; // fall through to /cart link
      e.preventDefault();
      openDrawer(opener.dataset.openDrawer);
      return;
    }
    const closer = e.target.closest('[data-close-drawer]');
    if (closer) closeDrawer(closer.closest('.drawer'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Cart (AJAX + Section Rendering API) ---------- */
  function toast(msg) {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._h);
    t._h = setTimeout(() => t.classList.remove('is-visible'), 2600);
  }

  async function refreshCart(sectionsHtml) {
    let html = sectionsHtml;
    if (!html) {
      const res = await fetch(`${routes.root}?sections=cart-drawer,main-cart`.replace('//?', '/?'));
      html = await res.json();
    }
    if (html['cart-drawer']) {
      const doc = new DOMParser().parseFromString(html['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('#CartDrawerInner');
      const cur = $('#CartDrawerInner');
      if (fresh && cur) cur.replaceWith(fresh);
    }
    if (html['main-cart'] && $('#MainCart')) {
      const doc = new DOMParser().parseFromString(html['main-cart'], 'text/html');
      const fresh = doc.querySelector('#MainCart');
      if (fresh) $('#MainCart').replaceWith(fresh);
    }
    const count = $('#CartDrawerInner')?.dataset.count ?? $('#MainCart')?.dataset.count;
    if (count !== undefined) $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.dataset.count = count; });
  }

  async function changeLine(line, quantity) {
    const res = await fetch(`${routes.cart_change_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: ['cart-drawer', 'main-cart'] }),
    });
    const data = await res.json();
    if (!res.ok) { toast(data.description || data.message || 'Could not update cart'); return; }
    await refreshCart(data.sections);
  }

  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const wrap = step.closest('.qty');
      const input = $('input', wrap);
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
      if (wrap.dataset.line) { e.preventDefault(); changeLine(+wrap.dataset.line, next); }
      else input.value = Math.max(1, next);
      return;
    }
    const remove = e.target.closest('[data-remove-line]');
    if (remove) { e.preventDefault(); changeLine(+remove.dataset.removeLine, 0); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('.qty[data-line] input');
    if (input) changeLine(+input.closest('.qty').dataset.line, Math.max(0, parseInt(input.value, 10) || 0));
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || cartType !== 'drawer') return;
    e.preventDefault();
    const btns = $$(`[type="submit"][form="${form.id}"], [type="submit"]`, document).filter((b) => b.form === form);
    btns.forEach((b) => b.classList.add('is-loading'));
    const err = $('.form-error', form.closest('[data-product]') || form);
    if (err) err.hidden = true;
    const body = new FormData(form);
    body.append('sections', 'cart-drawer,main-cart');
    try {
      const res = await fetch(`${routes.cart_add_url}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      await refreshCart(data.sections);
      openDrawer('CartDrawer');
    } catch (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; } else toast(ex.message);
    } finally {
      btns.forEach((b) => b.classList.remove('is-loading'));
    }
  });

  /* ---------- Product: variants, price, gallery ---------- */
  function money(cents) {
    const fmt = window.EmberMoneyFormat || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    const [whole, dec] = value.split('.');
    const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${dec}`)
      .replace(/\{\{\s*amount\s*\}\}/, `${withCommas}.${dec}`);
  }

  $$('[data-product]').forEach((root) => {
    const json = $('script[data-product-json]', root);
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = form && $('input[name="id"]', form);
    const slides = $$('.gallery__slide', root);
    const thumbs = $$('.gallery__thumb', root);
    const atcButtons = () => $$('[data-atc]').filter((b) => b.form === form || b.getAttribute('form') === form?.id);

    function showSlide(i) {
      if (!slides.length) return;
      const n = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === n));
      thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === n); if (k === n) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); });
      slides.forEach((s, k) => { if (k !== n) $$('video', s).forEach((v) => v.pause()); });
      root.dataset.slide = n;
    }
    thumbs.forEach((t, k) => t.addEventListener('click', () => showSlide(k)));
    $('[data-gallery-prev]', root)?.addEventListener('click', () => showSlide(+(root.dataset.slide || 0) - 1));
    $('[data-gallery-next]', root)?.addEventListener('click', () => showSlide(+(root.dataset.slide || 0) + 1));

    let touchX = null;
    const main = $('.gallery__main', root);
    main?.addEventListener('touchstart', (e) => { touchX = e.touches[0].clientX; }, { passive: true });
    main?.addEventListener('touchend', (e) => {
      if (touchX === null) return;
      const dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) showSlide(+(root.dataset.slide || 0) + (dx < 0 ? 1 : -1));
      touchX = null;
    });

    const lightbox = $('.lightbox', root);
    $$('.gallery__zoom', root).forEach((z) => z.addEventListener('click', () => {
      if (!lightbox) return;
      const target = $('[data-lightbox-target]', lightbox);
      const img = document.createElement('img');
      img.src = z.dataset.full;
      img.alt = target.dataset.alt || '';
      target.replaceChildren(img);
      lightbox.showModal();
    }));
    lightbox?.addEventListener('click', (e) => { if (e.target === lightbox || e.target.closest('.lightbox__close')) lightbox.close(); });

    function selectedOptions() {
      return $$('.variant-picker', root).map((fs) => {
        const checked = $('input:checked', fs) || $('select', fs);
        return checked ? checked.value : null;
      });
    }

    function update() {
      const opts = selectedOptions();
      const variant = product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      $$('.variant-picker', root).forEach((fs, i) => {
        const span = $('legend span', fs);
        if (span) span.textContent = opts[i];
        // grey out values that don't exist with the other current selections
        $$('input', fs).forEach((inp) => {
          const ok = product.variants.some((v) => v.available && v.options[i] === inp.value
            && v.options.every((o, k) => k === i || o === opts[k]));
          inp.classList.toggle('is-unavailable', !ok);
        });
      });
      atcButtons().forEach((b) => {
        const label = $('[data-atc-label]', b) || b;
        if (!variant) { b.disabled = true; label.textContent = b.dataset.unavailable; }
        else if (!variant.available) { b.disabled = true; label.textContent = b.dataset.soldout; }
        else { b.disabled = false; label.textContent = b.dataset.add; }
      });
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      $$('[data-price]').forEach((el) => { el.textContent = money(variant.price); });
      const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      $$('[data-compare]').forEach((el) => { el.textContent = hasCompare ? money(variant.compare_at_price) : ''; el.hidden = !hasCompare; });
      $$('[data-save]').forEach((el) => {
        el.hidden = !hasCompare;
        if (hasCompare) {
          const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          el.textContent = el.dataset.template.replace('[percent]', pct).replace('[amount]', money(variant.compare_at_price - variant.price));
        }
      });
      if (variant.featured_media) {
        const k = slides.findIndex((s) => +s.dataset.mediaId === variant.featured_media.id);
        if (k > -1) showSlide(k);
      }
      if (root.dataset.updateUrl !== 'false') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
    $$('.variant-picker input, .variant-picker select', root).forEach((el) => el.addEventListener('change', update));
    if ($('.variant-picker', root)) update();
  });

  /* ---------- Sticky add-to-cart ---------- */
  const sticky = $('.sticky-atc');
  const anchor = $('[data-sticky-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', past);
    }).observe(anchor);
  }

  /* ---------- Low-stock bar width ---------- */
  $$('[data-stock-pct]').forEach((el) => { el.style.width = `${el.dataset.stockPct}%`; });
})();
